<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5 text-center" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="mb-4" >
                <template #default>اطلاعات شما با موفقیت ذخیره شد.   </template>
                </m-h4><m-h4 v-bind='{...{},...{}}' :style='""' class="mb-4 h5" >
                <template #default>همکاران ما در اولین فرصت با شما تماس خواهند گرفت.   </template>
                </m-h4><m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="btn btn-secondary col-lg-6 mx-auto rounded-pill" >
                <template #default>بازگشت به خانه   </template>
                </m-a></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH4,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
